import {
    TEMPLATE_LIST,
    TEMPLATE_PAGE_LIST,
    HIDE_LOADING,
    SET_ADD_EDIT,
    SHOW_LOADING,
    TEMPLATE_MESSAGE,
    TEMPLATE_PAGE_DRAFT_LIST,
    TEMPLATE_PAGE_DRAFT_MESSAGE,
    TAB_VALUE,
    TEMPLATE_LIST_WITH_PAGES
  } from "redux/constants/templatePage";
  
  const initState = {
    selectedTab:"drafts",
    loading: true,
    addEditPagesValue : false,
    templates: [],
    templatesWithPages:[],
    templatePagesDrafts:[],
    templatePages:[],
    permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
  };
  
  const app = (state = initState, action) => {
    switch (action?.type) {
        case TEMPLATE_LIST:
            return {
              ...state,
              templates: action.payload,
              addEditPagesValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            };
        case TEMPLATE_LIST_WITH_PAGES:
          return {
            ...state,
            templatesWithPages: action.payload,
            addEditPagesValue:false,
            allowRedirect: false,
            loading: false,
            message: "",
          };
        case TEMPLATE_MESSAGE:
            return {
                ...state,
                message: messageRead(action),
                status: action?.response?.status,
                showMessage: true,
                loading: false,
              };
        case TEMPLATE_PAGE_DRAFT_LIST:
            return {
              ...state,
              templatePagesDrafts: action.payload,
              addEditPagesValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            };
        case TEMPLATE_PAGE_LIST:
          return {
            ...state,
            templatePages: action.payload,
            addEditPagesValue:false,
            allowRedirect: false,
            loading: false,
            message: "",
          };
        case TEMPLATE_PAGE_DRAFT_MESSAGE:
            return {
                ...state,
                message: messageRead(action),
                status: action?.response?.status,
                showMessage: true,
                loading: false,
              };
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true,
            };
            }
        case HIDE_LOADING: {
        return {
            ...state,
            loading: false,
        };
        }
        case SET_ADD_EDIT:
            return {
              ...state,
              addEditPagesValue: action.addEditPagesValue,
              loading: false,
              appRolePermissions: [],
            };
        case TAB_VALUE:
           return {
              ...state,
              selectedTab : action?.selectedTab,
              addEditPagesValue:false
           }
      default:
        return state;
    }
  };
  
  const messageRead=(action)=>{
    if(action?.response?.status==401 || action?.response?.response?.status){
      return "Unauthorized"
    }
      if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.data?.message){
       return action?.response?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.error){
          return action?.response?.data?.error;
      }else if(action?.data?.message){
          return action?.data?.message;
      }else if(action?.data){
          return action?.data;
      }else{
          return "something went wrong"
      }
  }
  
  export default app;
  